// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"eee2a3fb","496":"e9b3a798"}[chunkId] + ".chunk.js";
};